module.exports = __webpack_public_path__ + "img/station_icon.8acbe159.png";